import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FlexibleQuotaModalProps } from './FlexibleQuotaModal';

export const openFlexibleQuotaModal = ({ onClose, ...data }: FlexibleQuotaModalProps) =>
    openPopupHelper({ popupName: popupNames.FLEXIBLE_QUOTA_MODAL, data, onClose });

export const closeFlexibleQuotaModal = () => closePopupHelper(popupNames.FLEXIBLE_QUOTA_MODAL);
